import React, { useEffect, useRef } from 'react';
import './commissions.scss';
import { DataGrid, LoadPanel, Menu, Popup } from 'devextreme-react';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import GlobalParams from '../../helpers/GlobalParams.js';
import { Column, Item } from 'devextreme-react/cjs/data-grid.js';
import axios from 'axios';
import notify from 'devextreme/ui/notify';
import ApiPostHelper from '../../helpers/ApiPostHelper.js';

const Commissions = () => {

  const [commissionsData, setCommissionsData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);


  const fetchCommissions = async () => {
    try {
      //use axios to fetch data get
      const response = await axios.get(
        GlobalParams.ApiUrlPrefix + "broker-commissions?broker_id=" + GlobalParams.IntermediaryId,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken // Include bearer token in the Authorization header
          }
        }
      );
      setIsLoading(false);
      setCommissionsData(response.data.data);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  }

  useEffect(() => {
    setIsLoading(true);
    fetchCommissions();
  }, []);

  //////report popup//////////
  const containerRef = useRef(null);
  const renderPdfViewer = (base64PDF) => {
    const container = containerRef.current;

    if (container) {
      const viewerObject = document.createElement('object');
      viewerObject.type = 'application/pdf';
      viewerObject.style.width = '100%';
      viewerObject.style.height = '800px';
      viewerObject.data = 'data:application/pdf;base64,' + base64PDF;

      container.appendChild(viewerObject);
    }
  };
  const fetchRpt = async (url) => {
    try {

      const result = await ApiPostHelper.postData(
        GlobalParams.LoginApiUrlPrefix + 'getReportsLaravel',
        GlobalParams.bearerToken,
        JSON.stringify({
          url_path: url,
        })
      );

      console.log("I am here brother");
      console.log(result.success);
      if (!result.success) {
        setIsLoading(false);
        setPopupReportVisible(false);
        notify("Report Error", 'error', 5000);
      }

      console.log(result.data);
      setPopupReportVisible(true);
      // Delay setting isLoading to false until after renderPdfViewer completes
      renderPdfViewer(result.data);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify("Error Fetching the report", 'error', 5000);
    } finally {
      // Set isLoading to false after renderPdfViewer completes
      setIsLoading(false);
    }
  };
  const [popupReportVisible, setPopupReportVisible] = React.useState(false);
  const [report_name, setreport_name] = React.useState('');
  const hideReportButtonClick = () => {
    if (containerRef.current) {
      containerRef.current.innerHTML = '';
    }
    setPopupReportVisible(false);
  };
  //////end of report popup///

  const onMenuItemClick = (cellInfo, item) => {

    if (item === 'Schedule Summary') {
      console.log('Schedule Summary');
      setIsLoading(true);
      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=017&referenceNumber=' + cellInfo.data.CommissionReference + '&email=' +
        GlobalParams.UserEmail;

      fetchRpt(url);
    } else if (item === 'Detailed Summary') {

      console.log('Endorsement Costing Schedule');
      setIsLoading(true);
      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=018&referenceNumber=' + cellInfo.data.CommissionReference + '&email=' +
        GlobalParams.UserEmail;

      fetchRpt(url);
    } else if (item === 'Remittance Advise') {

      console.log('Endorsement Costing Schedule');
      setIsLoading(true);
      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=019&referenceNumber=' + cellInfo.data.CommissionReference + '&email=' +
        GlobalParams.UserEmail;

      fetchRpt(url);
    }

  };
  const menuItems = [
    { text: 'Schedule Summary', icon: 'doc' },
    { text: 'Detailed Summary', icon: 'doc' }
    // { text: 'Remittance Advise', icon: 'doc' }
  ];
  const actionColumnTemplate = (cellInfo) => {
    return (
      <div>
        <Menu
          onItemClick={(e) => onMenuItemClick(cellInfo, e.itemData.text)}
        >
          <Item
            text=" "
            items={menuItems}
          >
          </Item>
        </Menu>
      </div>
    );
  };


  return (
    <div>
      <LoadPanel visible={isLoading} />
      <div>
        <Popup style={{
          padding: 20,
        }}
          visible={popupReportVisible}
          title={report_name}
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={false}
          onHiding={hideReportButtonClick}
        >
          <LoadPanel visible={isLoading} />
          <div ref={containerRef} id="pdf-container"></div>
        </Popup>
      </div>
      {/*create a pop up - display the amount and phone number to send the prompt to*/}
      <br />
      <div style={{ color: '#2E86C1', fontWeight: 'bold' }}>Commissions</div>
      {
        <DataGrid
          dataSource={commissionsData}
          wordWrapEnabled={true}
          searchPanel={
            {
              visible: false,
              width: 250
            }
          }
        >
          <Column width={50} caption="" cellRender={actionColumnTemplate} />
          <Column dataField="id" visible={false}></Column>
          <Column dataField="CommissionReference" visible={false}></Column>
          <Column dataField="requisition_no" visible={false}></Column>
          <Column dataField="DateTo" dataType='date'></Column>
          <Column dataField="TotalGrossCommission" cellRender={(cellInfo) => {
            const formattedAmount = parseFloat(cellInfo.data.TotalGrossCommission).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            return (
              <span>{formattedAmount}</span>
            );
          }}> </Column>
          <Column dataField="TotalWTax" cellRender={(cellInfo) => {
            const formattedAmount = parseFloat(cellInfo.data.TotalWTax).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            return (
              <span>{formattedAmount}</span>
            );
          }}> </Column>
          <Column dataField="TotalVAT" cellRender={(cellInfo) => {
            const formattedAmount = parseFloat(cellInfo.data.TotalVAT).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            return (
              <span>{formattedAmount}</span>
            );
          }}> </Column>
          <Column dataField="TotalNetCommission" cellRender={(cellInfo) => {
            const formattedAmount = parseFloat(cellInfo.data.TotalNetCommission).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            return (
              <span>{formattedAmount}</span>
            );
          }}> </Column>
        </DataGrid>
      }
    </div>
  );
}
export default Commissions;